/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_9_QInputs */

const en_tut_tr_9_q = /** @type {(inputs: Tut_Tr_9_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My guest cannot get in even though I sent the link.`)
};

const id_tut_tr_9_q = /** @type {(inputs: Tut_Tr_9_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu saya tidak bisa masuk padahal tautannya sudah dikirim.`)
};

/**
* | output |
* | --- |
* | "My guest cannot get in even though I sent the link." |
*
* @param {Tut_Tr_9_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_9_q = /** @type {((inputs?: Tut_Tr_9_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_9_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_9_q(inputs)
	return en_tut_tr_9_q(inputs)
});